import React, { memo } from "react";
import { Calendar, Clock, FileText } from "lucide-react";

export const MonthlyCard = memo(function MonthlyCard({ stats, onClick, disabled = false }) {
  const daysColor = stats.actualWorkingDays === stats.totalWorkingDays ? "#198754" : "#dc3545";
  
  return (
    <button
      onClick={!disabled && onClick}
  className={`card shadow-sm p-4 text-start ${!disabled ? "monthly-card" : ""}`}
      style={disabled ? { ...cardStyle, ...disabledCardStyle } : cardStyle}
      disabled={disabled}
    >
      <div className="d-flex align-items-center justify-content-center gap-2 ">
        <div
          className="d-flex align-items-center justify-content-center p-2 rounded"
          style={calendarContainerStyle}
        >
          <Calendar style={calendarIconStyle} />
        </div>

        <h6 className="fw-semibold mb-0" style={monthTextStyle}>
          {stats.month}
        </h6>
      </div>

      <div className="d-flex justify-content-between">
        <div className="text-center">
          <div className="d-flex align-items-center justify-content-center gap-1 mb-1">
            <Clock style={clockIconStyle} />
            <p className="fw-bold mb-0" style={statValueStyle}>
              {stats.loggedHours?.toFixed(1)}
            </p>
          </div>
          <p className="text-muted small mb-0">Hours</p>
        </div>

        <div className="text-center">
          <div className="d-flex align-items-center justify-content-center gap-1 mb-1">
            <FileText style={fileIconStyle} />
            <p className="fw-bold mb-0" style={{ ...statValueStyle, color: daysColor }}>
              {stats.actualWorkingDays}/ {stats.totalWorkingDays}
            </p>
          </div>
          <p className="text-muted small mb-0">Days</p>
        </div>
      </div>
    </button>
  );
});

const cardStyle = {
  minWidth: "100px",
  borderRadius: "12px",
  transition: "transform 0.2s ease-in-out",
};

const calendarContainerStyle = {
  backgroundColor: "#0d6efd20",
};

const calendarIconStyle = {
  width: "18px",
  height: "18px",
  color: "#0d6efd",
};

const monthTextStyle = {
  color: "#0d6efd",
};

const clockIconStyle = {
  width: "16px",
  height: "16px",
  color: "#198754",
};

const fileIconStyle = {
  width: "16px",
  height: "16px",
  color: "#dc3545",
};

const statValueStyle = {
  fontSize: "1.1rem",
};

const disabledCardStyle = {
  backgroundColor: "#f8f9fa",
  opacity: 0.6,
  cursor: "not-allowed",
  color: "#6c757d",
};

